import React from 'react'

const RedArrowDown = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.879 7.846a.667.667 0 0 1 .942.032l3.512 3.764V2.667a.667.667 0 0 1 1.334 0v8.975l3.512-3.764a.667.667 0 1 1 .975.91l-4.667 5a.667.667 0 0 1-.974 0l-4.667-5a.667.667 0 0 1 .033-.942z" fill="#DD3623"/>
    </svg>

)

export default RedArrowDown
